import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { footerUrl, headerUrl, previewContentPrefix } from "@/constants"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import AemGrid from "@/components/AemGrid"
import {
  buildUrlForAemApim,
  filterBackEndJson,
  getDataLayerObj,
} from "@/utils/helper"
import {
  aemApimAxiosInstance,
  aemAxiosInstance,
  aemPreviewAxiosInstance,
} from "@/constants/api"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import usePageAuth from "@/hooks/usePageAuth"
import BreadCrumb from "@/components/Default/BreadCrumb"
import {
  setDatalayerPageName,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import { getStatesAndCitiesFromServer } from "@/utils/findStore"

const KECTypes = ({
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  globalScript,
  footerScript,
  analysticsScript,
  kecTypeID,
  analyticsData,
  gbhDataLayerCustom,
  datalayerPageName,
  stateWithCities,
}) => {
  usePageAuth()

  const dispatch = useDispatch()
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])

  useEffect(() => {
    dispatch(setDatalayerPageName(datalayerPageName))
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => {
      dispatch(setDatalayerPageName(""))
      dispatch(setGbhDataLayerCustom(""))
    }
  }, [])
  return (
    <>
      <GlobalPageHeader
        header={header}
        title={data?.title}
        globalScripting={globalScript}
        analysticsScript={analysticsScript}
      />
      <AemGrid
        data={data}
        count={0}
        breadCrumb={(data, fullData) => (
          <BreadCrumb data={data} fullData={fullData} />
        )}
        stateWithCities={stateWithCities}
      />
      <GlobalPageFooter footer={footer} footerScripting={footerScript} />
    </>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, res, locale, query }) {
  // export async function getServerSideProps({ req, locale }) {
  const { kectypes: id = "" } = query
  const pageUrl = `/locations/find-a-store/${id}.model.json`
  const isPreviewMode = req.cookies["aem-author-preview-mode"]
  const stateWithCitiesResult = await getStatesAndCitiesFromServer()
  const stateWithCities = stateWithCitiesResult.result.data
  const { data } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: previewContentPrefix + pageUrl,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: buildUrlForAemApim(pageUrl),
        method: "GET",
      })

  const { data: header } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.headerExpFrg
          ? buildUrlForAemApim(`${data.headerExpFrg}.model.json`)
          : buildUrlForAemApim(`${headerUrl}.model.json`),
        method: "get",
      })

  const { data: footer } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
    : await aemApimAxiosInstance({
        url: data.footerExpFrg
          ? buildUrlForAemApim(`${data.footerExpFrg}.model.json`)
          : buildUrlForAemApim(`${footerUrl}.model.json`),
        method: "GET",
      })
  const globalScript = data?.globalScript || null
  const footerScript = data?.footerScript || null
  const topHeadScript = data?.topHeadScript || null
  const analysticsScript = data?.adobeAnalytic || null

  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  tmpData = filterBackEndJson(tmpData)
  const analyticsData = data?.data || null
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  let kecTypeID = id
  const datalayerPageName = data?.datalayerPageName
  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  return {
    props: {
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      analyticsData,
      footerScript,
      topHeadScript,
      analysticsScript,
      datalayerPageName,
      gbhDataLayerCustom,
      kecTypeID,
      stateWithCities,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default KECTypes
